var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 18C10.75 19.6569 9.40685 21 7.75 21H3.75C2.09315 21 0.75 19.6569 0.75 18V16C0.75 14.3431 2.09315 13 3.75 13H10.75V18ZM20.25 13C21.9069 13 23.25 14.3431 23.25 16V18C23.25 19.6569 21.9069 21 20.25 21H16.25C14.5931 21 13.25 19.6569 13.25 18V13H20.25ZM14.75 3C16.4069 3 17.75 4.34315 17.75 6V10C17.75 10.5523 17.3023 11 16.75 11H7.25C6.69772 11 6.25 10.5523 6.25 10V6C6.25 4.34315 7.59315 3 9.25 3H14.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntities);
export default __webpack_public_path__ + "static/media/entities.d1a055010565d57a5e75ef2b4d7ec70d.svg";
export { ForwardRef as ReactComponent };